import { sortBy } from "lodash";
import { useQuery } from "react-query";
import { segmentsApi } from "@/react/api/segmentsApi";
import { queryClient } from "@/react/providers/QueryClient";

export const WORKFLOW_SEGMENTS_QUERY_KEY_PREFIX = "workflow-segments-list";

interface UseFetchSegmentsParams {
  segmentIds?: number[];
  workflowId: string;
}

const getWorkflowSegmentsQueryKey = ({
  workflowId,
  segmentIds = [],
}: UseFetchSegmentsParams) => {
  if (segmentIds.length === 0) {
    return [WORKFLOW_SEGMENTS_QUERY_KEY_PREFIX, workflowId];
  }

  return [
    WORKFLOW_SEGMENTS_QUERY_KEY_PREFIX,
    workflowId,
    sortBy(segmentIds).join(","),
  ];
};

export const invalidateWorkflowSegmentsQuery = async ({
  workflowId,
  segmentIds = [],
}: UseFetchSegmentsParams) => {
  await queryClient.invalidateQueries(
    getWorkflowSegmentsQueryKey({ workflowId, segmentIds }),
  );
};

export const useFetchSegments = ({
  workflowId,
  segmentIds = [],
}: UseFetchSegmentsParams) => {
  const queryKey = getWorkflowSegmentsQueryKey({ workflowId, segmentIds });

  return useQuery(
    queryKey,
    () =>
      segmentsApi.list({
        params: {
          ids: segmentIds,
          per_page: 100,
        },
      }),
    {
      enabled: segmentIds.length > 0,
      keepPreviousData: false,
    },
  );
};
